export class EmployeeAvailabilityDto {
    all: number;
    active: number;
    inactive: number;
}
